import DomHelper from '../../DomHelper'
import StoreHelper from '../../../store/helper'

export const onDroppableBubbleDragover = (component, e) => {
  e.preventDefault()
  DomHelper.scaleElement(e.target, 1.1)

  if (!StoreHelper.isDropTargetDefined()) {
    StoreHelper.setDropTarget(e.target)
  }
}
